import { __ } from '@wordpress/i18n';
import { InnerBlocks, InspectorControls } from '@wordpress/block-editor';
import{Panel, PanelBody, DateTimePicker, FormToggle, PanelRow, Button, Popover } from "@wordpress/components"
import { dateI18n } from "@wordpress/date"
import { useState, Fragment  } from "@wordpress/element";

export default function Edit(props){
    const { attributes, setAttributes, clientId } = props;
    const { blockId, schedule_program, schedule_init, schedule_end, showSlide} = attributes;

    const scheduleInit = dateI18n( 'F j, Y g:i a', schedule_init);
    const currentDay = dateI18n( 'F j, Y g:i a', new Date() );
    const scheduleEnd = dateI18n( 'F j, Y g:i a', schedule_end );
    
    const programSlider = ()=>{

        if(schedule_program == true){

            if(scheduleInit < currentDay && currentDay < scheduleEnd){
                setAttributes({showSlide:true})
            }else{
                setAttributes({showSlide:false})
            }

        }else{
            setAttributes({showSlide:true})
        }
    }

    programSlider();
    
    let displaySlide = ''; 
    showSlide == false ? displaySlide = 'has-hidden-slide': '';


    if ( ! blockId ) {
        setAttributes( { blockId: clientId } );
    }

    
    const [openDatePopup, setOpenDatePopup] = useState( false );
    const [openDatePopupEnd, setOpenDatePopupEnd] = useState( false );
    
    return(    
        <>
            <Fragment>
                <InspectorControls>
                    <Panel>
                        <PanelBody title={__('Programaciones slider')} className="date-options" initialOpen={ false }>
                            <div className='date-options__activation'>
                                <label className='navigations__dots'>Programar slide  </label>
                                <FormToggle
                                    checked={ schedule_program }
                                    onChange={()=>{
                                        setAttributes({schedule_program:!schedule_program})
                                    }}
                                />
                            </div>
                            <div style={{display: schedule_program == true ? 'block' : 'none' }}>
                                <PanelRow>
                                    <h4 className='has-negro-color'>Fecha inicial</h4>
                                    <Button isLink={true} onClick={() => setOpenDatePopup( ! openDatePopup )}>
                                        { schedule_init ? dateI18n( 'F j, Y g:i a', schedule_init ) : "Selecciona fecha de inicio" }
                                    </Button>
                                    { schedule_init ?  
                                        <Button onClick={ ()=>setAttributes({
                                            schedule_init:''
                                        })}  isLink sDestructive>{__('Remover fecha')}
                                        </Button> : ''
                                    }
                                    { openDatePopup && (
                                        <Popover onClose={ setOpenDatePopup.bind( null, false )} className="date-popup">
                                        <DateTimePicker
                                                currentDate={schedule_init}
                                                startOfWeek = {1}
                                                is12Hour={ true }
                                                onChange={(NewScheduleInit)=> setAttributes({
                                                    schedule_init: NewScheduleInit,
                                                })}
                                            />
                                        </Popover>
                                    ) }
                                </PanelRow>
                                <PanelRow>
                                    <h4 className='has-negro-color'>Fecha Final</h4>
                                    <Button isLink={true} onClick={() => setOpenDatePopupEnd( ! openDatePopupEnd )}>
                                        { schedule_end ? dateI18n( 'F j, Y g:i a', schedule_end ) : "Selecciona fecha final" }
                                    </Button>
                                    { schedule_end ?  
                                        <Button onClick={()=>setAttributes({
                                            schedule_end:''
                                        })} isLink sDestructive>{__('Remover fecha')}</Button> : ''
                                    }
                                    { openDatePopupEnd && (
                                        <Popover onClose={ setOpenDatePopupEnd.bind( null, false )} className="date-popup">
                                        <DateTimePicker
                                                currentDate={schedule_end}
                                                startOfWeek = {1}
                                                is12Hour={ true }
                                                onChange={(NewScheduleEnd)=> setAttributes({
                                                    schedule_end: NewScheduleEnd,
                                                })}
                                            />
                                        </Popover>
                                    ) }
                                </PanelRow>
                            </div>
                        </PanelBody>
                    </Panel>
                </InspectorControls>
                
                <div className={'item-slider-content ' + displaySlide} >
                    <InnerBlocks/>
                </div>
            </Fragment>
        </>
        
    )
}
